import React from 'react';
import ReactModal from 'react-modal';
import { css, cx } from '@emotion/css';
import { IconClose, theme, useLocalizationContext } from '@contrast-security-inc/design-system-foundations';
import { IconButton } from '@contrast-security-inc/design-system-buttons';
import * as messages from '../translations';
const openTimeInSeconds = 0.425;
const closeTimeInSeconds = 0.3;
const overlayClasses = {
    base: css `
    z-index: 1002;
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    display: block;
    overflow-y: auto;
    background-color: rgba(0, 0, 0, 0);
    transition: background-color ${openTimeInSeconds}s linear;
  `,
    afterOpen: css `
    overflow-y: auto;
    overflow-x: hidden;
    background-color: ${theme.color.neutral10};
  `,
    beforeClose: css `
    transition: background-color ${closeTimeInSeconds}s linear;
    background-color: rgba(0, 0, 0, 0);
  `,
};
const contentClasses = {
    base: css `
    position: relative;
    outline: none;
    transition: opacity ${openTimeInSeconds}s ease-out;
    opacity: 0;
    pointer-events: none;
    height: 100%;

    > * {
      margin-bottom: 150px;
    }
  `,
    afterOpen: css `
    opacity: 1;
  `,
    beforeClose: css `
    transition: opacity ${closeTimeInSeconds}s ease-out;
    opacity: 0;
  `,
};
const containerCss = css `
  display: flex;
  flex-direction: column;
  pointer-events: auto;
  margin: 0;
  background-color: ${theme.color.white};
  height: 100%;
`;
const headerContainerCss = css `
  display: flex;
  align-items: center;
  background-color: ${theme.color.neutral20};
  padding: 18px 20px;
  border-radius: 4px 4px 0 0;
  border-bottom: 1px solid ${theme.color.neutral30};
`;
const titleContainerCss = css `
  flex: 1 1 auto;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  word-wrap: normal;
`;
const closeIconCss = css `
  margin-left: 8px;
`;
const styledProps = {
    overlayClassName: overlayClasses,
    className: contentClasses,
    closeTimeoutMS: closeTimeInSeconds * 1000,
};
export const FullscreenModal = React.forwardRef(({ children, HeaderProps, isOpen = false, onClose, testId, ...props }, ref) => {
    const { formatMessage } = useLocalizationContext();
    return (React.createElement(ReactModal, { ...styledProps, ...props, ariaHideApp: false, isOpen: isOpen, onRequestClose: onClose, testId: testId, ref: ref, shouldCloseOnOverlayClick: false },
        React.createElement("div", { className: containerCss },
            React.createElement("div", { className: cx(headerContainerCss, HeaderProps?.headerContainerClassName) },
                HeaderProps?.renderTitle ? React.createElement("div", { className: titleContainerCss }, HeaderProps.renderTitle()) : null,
                onClose ? (React.createElement(IconButton, { "aria-label": formatMessage(messages, 'close'), 
                    // eslint-disable-next-line react/display-name
                    Icon: React.forwardRef(() => (React.createElement(IconClose, { onClick: onClose, size: HeaderProps?.closeIconSize, className: cx(closeIconCss, HeaderProps?.closeIconClassName), testId: HeaderProps?.cancelIconTestID }))) })) : null),
            children)));
});
FullscreenModal.displayName = 'FullscreenModal';
